// RUNTIME environment. Values come from window.__env (assets/env.js), which is
// generated per-deploy by the container entrypoint. Build ONCE, configure per env.
//
// env.js is loaded by a <script> in index.html BEFORE the app bundle, so __env is
// populated by the time this module is evaluated (and before app.variables.ts runs).
//
// Static values that don't change across environments stay hard-coded below.
// With this in place, fileReplacements for stage/prod are no longer needed —
// make environment.stage.ts / environment.prod.ts re-export this file (or delete
// them and drop the fileReplacements entries from angular.json).

const env = (window as any).__env || {};

const pick = (key: string, fallback = ''): string =>
  env[key] != null && env[key] !== '' ? env[key] : fallback;

export const environment = {
  // ── runtime (per-env) ──
  baseUrl: pick('BASE_URL', 'http://localhost:5002/api'),
  domain: pick('DOMAIN', 'localhost:5002'),
  stsAuthority: pick('STS_AUTHORITY', 'https://dev.id.eris.efda.gov.et'),
  clientRoot: pick('CLIENT_ROOT', 'http://localhost:4200/'),
  /** HTTPS origin for EthSwitch HPP return (NGB rejects http://localhost). Set to cloudflared URL in local dev. */
  publicAppUrl: pick('PUBLIC_APP_URL', '').replace(/\/$/, ''),
  nidClientId: pick('NID_CLIENT_ID', 'crXYIYg2cJiNTaw5t-peoPzCRo-3JATNfBd5A86U8t0'),
  nidAuthEndpoint: pick('NID_AUTH_ENDPOINT', 'https://esignet.ida.fayda.et/authorize'),
  envName: pick('NG_APP_ENV', 'local'),

  // ── static (same everywhere) ──
  production: true,
  version: '2.16.6',
  clientId: 'ilicense-spa',
  clientScope: 'openid profile email ilicense',
  // '' = backend default; 'C2B' = H5 consumer; 'B2B' = H5 business.
  telebirrCheckoutMode: '',
};
